import { HeroSection } from "../components/HeroSection";
import { StarProductSection } from "../components/StarProductSection";
import { MarketingVideoSection } from "../components/MarketingVideoSection";
import { ClientsCarousel } from "../components/ClientsCarousel";
import { FeaturedProducts } from "../components/FeaturedProducts";
import { CallbackForm } from "../components/CallbackForm";
import { AboutSection } from "../components/AboutSection";
import { ContactSection } from "../components/ContactSection";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <StarProductSection />
      <MarketingVideoSection />
      <ClientsCarousel />
      <FeaturedProducts />
      <AboutSection />
      <CallbackForm />
      <ContactSection />
    </main>
  );
}
